<template>
  <div class="under-offer form-group">
    <p>Is the property under offer?</p>
    <div class="subsection">
      <label for="comments">Comments</label>
      <textarea id="comments" rows="5" v-model="comment" />
    </div>
    <div class="subsection">
      <oa-button
        :text="'Yes, this property is under offer'"
        :btnClass="{ color: 'green' }"
        :disabled="disableSubmit"
        @click="isUnderOffer"
        v-gaEvent="gaEvent('Leads Management - Click update lead submit - Under Offer')"
      />
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';
import { LeadStageType, LeadStageTypeId } from '@/Mapper/LeadStageType';
import OaButton from '@/components/Forms/OaButton';
import StageUpdate from '@/mixins/StageUpdate';

export default {
  name: 'UnderOffer',
  mixins: [StageUpdate],
  components: {
    OaButton,
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      lam: state => state.leadAgentMappingStore.lam,
      lead: state => state.leadAgentMappingStore.lead,
    }),
  },
  data() {
    return {
      disableSubmit: false,
      comment: '',
    };
  },
  methods: {
    ...mapActions('leadAgentMappingStore', [
      'updateLeadStage',
    ]),
    createCaseForUnderOfferUpdate() {
      const caseData = {
        leadkey: this.lead.key,
        agentkey: this.$route.params.ak,
        // agentkey: this.agent.key,
        leadstatus: LeadStageTypeId[LeadStageType.Pre_Sale],
        comment: this.comment,
      };
      return this.$apiServices.oa.lead.createCaseForLeadUpdate(caseData);
    },
    isUnderOffer() {
      this.disableSubmit = true;
      this.moveLeadToUnderOffer()
        .then(() => {
          if (this.comment !== '' && this.comment.length > 0) {
            this.saveUnderOfferDetails();
          }
          this.createCaseForUnderOfferUpdate();
          this.logLeadEvent(
            'Leads Management - Submit status change - Under Offer',
            'Single Deal Page - Post-Listed',
          );
          this.disableSubmit = false;
        }).catch((err) => {
          this.disableSubmit = false;
          console.log(err);
        });
    },
    saveUnderOfferDetails() {
      const data = {
        leadid: this.lead.id,
        agentid: this.lam.agentid,
        // agentid: this.agent.id,
        notetypeid: 1,
        note: this.comment,
        sourcetypeid: this.isLamOwner ? 1 : 5,
      };
      return this.$apiServices.oa.note.create(data);
    },
    moveLeadToUnderOffer() {
      const payload = {
        leadkey: this.lead.key,
        data: {
          leadstagetypeid: LeadStageType.Pre_Sale,
          oauserkey: !!this.user && !!this.user.key ? this.user.key : this.agent.userkey,
          sourcetypeid: this.isLamOwner ? 1 : 5,
        },
      };
      return this.updateLeadStage(payload);
    },
  },
};

</script>

<style lang="scss" scoped>

.under-offer .btn {
  margin-bottom: 15px;
}

.under-offer .subsection {
  @apply ut-pt-6;
}

.under-offer p {
  @apply ut-font-normal ut-text-lg ut-pb-3;
  line-height: 28px;
}

.under-offer label {
  @apply ut-font-bold ut-text-sm ut-pb-3 ut-tracking-normal;
  line-height: 24px;
}

.under-offer p.hint {
  @apply ut-text-sm ut-font-light ut-tracking-normal;
}

</style>
